import { render } from "./storeColumn.vue?vue&type=template&id=39436d7b&scoped=true"
import script from "./storeColumn.vue?vue&type=script&lang=js"
export * from "./storeColumn.vue?vue&type=script&lang=js"

import "./storeColumn.vue?vue&type=style&index=0&id=39436d7b&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39436d7b"]])

export default __exports__